import type { PreviewEnvironmentManager } from '../preview-environments/preview-environment-manager.js';
import type { LogFn } from '../log.js';
import type { BridgeIdentifiedPayload } from './bridge-identified-types.js';
import { createOnBridgeIdentified } from './create-bridge-identified-handler.js';
import type { BridgeHeartbeatController } from './heartbeat/controller.js';
import type { MainBridgeConnectionState } from './create-main-bridge-reconnect-state.js';

export function createBridgeIdentifiedWithHeartbeat(params: {
  previewEnvironmentManager: PreviewEnvironmentManager;
  firehoseServerUrl: string | undefined;
  workspaceId: string;
  state: MainBridgeConnectionState;
  log: LogFn;
  bridgeHeartbeat: BridgeHeartbeatController;
}): (msg: BridgeIdentifiedPayload) => void {
  const { bridgeHeartbeat, log, ...identifiedOpts } = params;
  const onBridgeIdentified = createOnBridgeIdentified({ ...identifiedOpts, logFn: log });

  return (msg: BridgeIdentifiedPayload) => {
    onBridgeIdentified(msg);
    bridgeHeartbeat.start();
  };
}
